export const formConfig: FormConfig = {
  data: [
    {
      cmpType: 'radioGroup',
      fieldName: 'responsible',
      label: '有无责任',
      validatorRules: [
        {
          required: true,
          message: '请选择有无责任',
        },
      ],
    },
    {
      cmpType: 'radioGroup',
      fieldName: 'technicalSupportAccidentLevel',
      label: '事故等级',
      validatorRules: [
        {
          required: true,
          message: '请选择事故等级',
        },
      ],
    },
    {
      cmpType: 'input',
      fieldName: 'accidentAddress',
      label: '发生位置',
      placeholder: '请输入详细位置',
      validatorRules: [
        {
          required: true,
          message: '请输入详细位置',
        },
      ],
    },
    {
      cmpType: 'textarea',
      fieldName: 'technicalSupportDescription',
      label: '问题描述',
      placeholder: '请输入事故描述',
      validatorRules: [
        {
          required: true,
          message: '请输入事故描述',
        },
      ],
      maxLength: 200,
    },
    {
      cmpType: 'dateTime',
      fieldName: 'accidentTime',
      label: '事故发生时间',
      validatorRules: [
        {
          required: true,
          message: '请选择时间',
        },
      ],
      customStyle: {
        width: '100%',
      },
    },
    {
      cmpType: 'remoteUpload',
      label: '补充凭证',
      fieldName: 'technicalSupportAttmentList',
      actionUrl: `${location.protocol}//${process.env.JDX_APP_FETCH_DATA_DOMAIN}/monitor/web/common/fileUpload`,
      showUploadList: false,
      max: 3,
      validatorRules: [
        {
          required: false,
          message: '请选择',
        },
      ],
    },
  ],
};

export type ValidationCtx = {
  fileUploading: boolean;
  vehicleName?: string;
  formInstance?: any;
};

type WhenPredicate = (ctx: ValidationCtx) => boolean;

/**
 * 事故单的校验条件与提示信息的映射关系
 */
export const ValidationMap: { when: WhenPredicate; message: string }[] = [
  {
    when: (ctx: ValidationCtx) => ctx.fileUploading,
    message: '存在上传中的文件，请上传完毕后操作！',
  },
  {
    when: (ctx: ValidationCtx) => !ctx.vehicleName || !ctx.formInstance,
    message: '数据异常，请退出重试！',
  },
  {
    when: (ctx: ValidationCtx) =>
      (ctx.formInstance?.getFieldValue('accidentAddress') ?? '')
        .toString()
        .trim() === '',
    message: '请输入发生位置',
  },
  {
    when: (ctx: ValidationCtx) =>
      (ctx.formInstance?.getFieldValue('technicalSupportDescription') ?? '')
        .toString()
        .trim() === '',
    message: '请输入问题描述',
  },
];
